/** Standard ease-out curve shared by v2 motion, matching the composer slider. */
export const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1];

/** Symmetric ease used for elements that move in and settle back. */
export const EASE_IN_OUT = [0.77, 0, 0.175, 1] as const;

/** Slide curve tuned for drawers and sheets. */
export const EASE_DRAWER = [0.32, 0.72, 0, 1] as const;

/** CSS-string form of {@link EASE_OUT} for inline/utility transitions. */
export const EASE_OUT_CSS = "cubic-bezier(0.22, 1, 0.36, 1)";

/**
 * Constant rate, for decorative loops that must not appear to accelerate.
 * A shimmer or a spinner easing in and out reads as stuttering rather than
 * continuous, so those are the one place a curve is wrong.
 */
export const EASE_LINEAR = "linear" as const;

/**
 * Motion duration scale (seconds) for app-chrome transitions, with CSS-string
 * forms for inline/utility use. Reach for a token rather than a fresh magic
 * number so the shell's motion stays consistent.
 */
export const DURATION_QUICK = 0.15;
export const DURATION_BASE = 0.2;
export const DURATION_SLOW = 0.3;
export const DURATION_QUICK_CSS = "150ms";
export const DURATION_BASE_CSS = "200ms";
export const DURATION_SLOW_CSS = "300ms";

/**
 * The button system's timing: fill and edge move over 180ms, the 1px press
 * settle over 160ms, and all three snap to 60ms while the pointer is down so a
 * press lands immediately. Listed per property — background-color,
 * border-color, transform — to match `transition-property` on the button.
 */
export const DURATION_CONTROL_CSS = "180ms, 180ms, 160ms";
export const DURATION_PRESS_CSS = "60ms";
/** The button system's curve: CSS's own `ease`, not the v2 ease-out. */
export const EASE_CONTROL_CSS = "ease";

/** Press feedback on buttons and other tappable surfaces. */
export const SPRING_PRESS = { type: "spring", stiffness: 500, damping: 30, mass: 0.6 } as const;

/** Content swaps where label or icon slots trade places inside a control. */
export const SPRING_SWAP = { type: "spring", stiffness: 460, damping: 30, mass: 0.55 } as const;

/** Overlay panel entrances such as modals and sheets summoned by pointer. */
export const SPRING_PANEL = { type: "spring", stiffness: 420, damping: 40, mass: 0.5 } as const;

/** Shared-layout glides for pills, indicators and panels morphing between positions. */
export const SPRING_LAYOUT = { type: "spring", stiffness: 360, damping: 32, mass: 0.6 } as const;

/** Cursor-follow physics for decorative mouse tracking such as magnetic, tilt and dock. */
export const SPRING_MOUSE = { stiffness: 200, damping: 15, mass: 0.3 } as const;
